import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { EventResponse } from "../../api/schemas/events";

/** All fetched pages flattened, plus the cursor for "Load more". */
export const Events = S.Struct({
	data: S.Array(EventResponse),
	nextCursor: S.Option(S.Number),
});
export type Events = typeof Events.Type;

export const Model = S.Struct({
	page: S.Literal("AuditLog"),
	search: S.String,
	events: apiData(Events).schema,
	/** v1 `isFetching` for the Load-more button; the list stays visible meanwhile. */
	loadingMore: S.Boolean,
});
export type Model = typeof Model.Type;
